/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterU = createReactComponent("outline", "letter-u", "IconLetterU", [["path", { "d": "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11", "key": "svg-0" }]]);

export { IconLetterU as default };
//# sourceMappingURL=IconLetterU.mjs.map
